export function convertStepToPolymerStage(step: number) {
  switch (step) {
    case 1:
      return "A1";
    case 2:
      return "A2";
    case 3:
      return "A3";
    case 4:
      return "A4";
    case 5:
      return "A5";
    default:
      return "A0";
  }
}

export function convertPolymerStageToStep(polymerStage: string | undefined) {
  switch (polymerStage) {
    case "A1":
      return 1;
    case "A2":
      return 2;
    case "A3":
      return 3;
    case "A4":
      return 4;
    case "A5":
      return 5;
    default:
      return 0;
  }
}
